import { type ReactNode, useState } from 'react';

import {
  PageTitleOverrideContext,
  SetPageTitleOverrideContext,
} from '@/shared/routes/page-title-context';

/**
 * Holds the dynamic page-title override (see page-title-context).
 *
 * The setter comes straight from useState, so it is referentially stable and
 * safe as a `useSetPageTitle` effect dependency.
 */
export default function PageTitleProvider({ children }: { children: ReactNode }) {
  const [override, setOverride] = useState<string | null>(null);

  return (
    <SetPageTitleOverrideContext.Provider value={setOverride}>
      <PageTitleOverrideContext.Provider value={override}>
        {children}
      </PageTitleOverrideContext.Provider>
    </SetPageTitleOverrideContext.Provider>
  );
}
